class SmartstoreConfigController extends AbstractSftpController
	@register()

	integrationId: 'smartstore'
